import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import LdsButton from "../../components/LdsButton";
import { SideBar } from "../../components/SideBar";
import { useSelector } from "react-redux";

import { ReactLoaderSpinner } from "../../components/ReactLoaderSpinner/index.js";
import cases from "../../assets/module-2/2-3-0-5-cases.png";
import LdsImage from "../../components/LdsImage";
import References from "../../components/References";

// services
import { useBookmarkModuleMutation } from "../../store/services/moduleServerApi";

const Module_2_1_1 = () => {
  const { pathname: pathName } = useLocation();
  const { menuItems } = useSelector((state) => state?.moduleSlice);

  const [bookmarkModule, { isLoading: isMenuLoading }] =
    useBookmarkModuleMutation();

  /* Start useEffect */
  useEffect(() => {
    bookmarkModule({ pathName });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // * onPageLoad
  /* End useEffect */

  return (
    <div className="row">
      {isMenuLoading && <ReactLoaderSpinner />}
      {menuItems?.id && <SideBar menuItems={[menuItems]} />}
      <div className="col-sm-8">
        <main className="module-content">
          <section>
            <h1 className="blue text-uppercase b mt-5 mb-4">
              2.3.0 Demonstration Cases
            </h1>
            <p className="me-4">Estimated time to complete: 1 minute</p>
          </section>

          <section className="row justify-content-center text-lg-start text-sm-center align-items-center mt-4 mb-4">
            <div className="col-lg-8  col-md-12 d-flex gap-4 flex-lg-row flex-column align-items-center">
              <LdsImage
                src={cases}
                alt="An icon showing a clipboard with a checklist above the number 5, labeled 'Cases' in blue text."
                className="mb-sm-4"
                style={{ maxWidth: "188px" }}
              />
              <h4 className="h4 b dark-gray">
                Let’s look at 5 demonstration case videos to prepare you to
                begin reading Amyvid scans yourself.
              </h4>
            </div>
          </section>

          <section className="button-control">
            <LdsButton
              classes="white-button mt-3 mb-3 prev"
              onClick={function navClick() {
                window.open("/module-2/module-2-2-11", "_self");
              }}
            >
              Previous Lesson
            </LdsButton>
            <LdsButton
              classes="blue-button mt-3 mb-5 align-self-right float-end next"
              onClick={function navClick() {
                window.open("/module-2/module-2-3-1", "_self");
              }}
            >
              Next Lesson
            </LdsButton>
          </section>
          <References>
            <p className="fz-sm gray">Amyvid (florbetapir F 18 injection). Prescribing Information. Lilly USA, LLC.</p>
          </References>
        </main>
      </div>
    </div>
  );
};

export default Module_2_1_1;
